import React from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";

const PortfolioItem = (props) => {
  const { t } = useTranslation();
  const { id, image, title, shortDescription } = props.portfolio;
  const { onClick } = props;

  return (
    <div className="w-full sm:w-1/2 p-2">
      <div
        className="h-full border border-border rounded p-6 group hover:border-cyan transition cursor-pointer"
        onClick={onClick}
      >
        <div className="relative mb-6 w-full h-48 bg-surfaceHi rounded overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover object-center group-hover:scale-105 transition duration-300"
          />
          <div className="absolute opacity-0 transition duration-200 bg-bg bg-opacity-80 w-full flex items-center justify-center h-full left-0 top-0 group-hover:opacity-100">
            <div className="text-text text-center">
              <FaArrowRight className="text-3xl mx-auto mb-2 text-amber" />
              <p className="font-mono text-xs uppercase tracking-wide">{t("portfolio.viewDetails")}</p>
            </div>
          </div>
        </div>
        <p className="font-mono text-xs text-muted mb-2">PROJ-{String(id).padStart(2, "0")}</p>
        <h3 className="text-lg font-medium text-text mb-2 group-hover:text-cyan transition">
          {title}
        </h3>
        <p className="text-prose text-[0.9375rem] leading-relaxed">{shortDescription}</p>
      </div>
    </div>
  );
};

export default PortfolioItem;
